<template>
  <div style="width: 100%;height: 100%;overflow:auto;">
    <div style="display: flex;margin-top: 10px">
      <el-select v-model="year" style="width: 150px;height: 35px;margin-left: 10px" @change="initData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="employeeId" filterable placeholder="员工" style="width: 200px;margin-left: 10px" @change="initData">
        <el-option v-for="employee in employeeList" :key="employee.id" :label="employee.full_name" :value="employee.id"></el-option>
      </el-select>
    </div>
    <div style="margin-top: 10px;margin-left: 10px" v-for="(item,index) in kpiList ">
      <div style="margin-top: 10px;font-size: 16px;"><b>{{ index + 1 }}. {{ item.kpiName }}：</b></div>
      <div style="display: flex;width: 100%;height: 300px;margin-top: 10px">
        <div style="width: 49%;height: 100%" :id="'employeeMonthChart-' + index "></div>
        <div style="width: 49%;height: 100%" :id="'employeeAccrueChart-' + index"></div>
      </div>
    </div>



  </div>

</template>

<script>

import dayjs from "dayjs";
import isLeapYear from 'dayjs/plugin/isLeapYear';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import * as echarts from "echarts";

dayjs.extend(isLeapYear);
dayjs.extend(dayOfYear);

export default {
  name: "EmployeeKpi",

  data(){
    return{
      year:'',
      yearList:[],
      employeeId:'',
      employeeList:[],
      kpiList:[],

    }
  },
  async created() {
    await this.getYearList();
    await this.getEmployeeList();
    await this.initData();

  },
  methods: {
    async initData(){
      await this.getKpiData();
      await this.renderEcharts();
    },

    async getYearList(){
      const now = dayjs();
      this.year = now.year() +'';
      this.yearList = await this.$http('sysDsService.getYears(10,1)')
    },
    async getEmployeeList(){
      this.employeeList = await this.$http('crmEmployeeService.getEmployeeByRole');
      if(this.employeeList.length > 0){
        this.employeeId = this.employeeList[0].id;
      }
    },

    async getKpiData(){
      let params = {year:this.year,employeeId:this.employeeId}
      this.kpiList = await this.$http('crmEmployeeService.getEmployeeMonthKpiData', params);
    },

    async renderEcharts() {
      for(let data of this.kpiList){
        let idx = this.kpiList.findIndex(item=>item.kpiName === data.kpiName);

        let monthData = data.monthData;
        let accrueData = data.accrueData;

        const monthChartDom = document.getElementById('employeeMonthChart-' + idx);
        const accrueChartDom = document.getElementById('employeeAccrueChart-' + idx);

        // 获取现有的 ECharts 实例（如果有）
        let myMonthChart = echarts.getInstanceByDom(monthChartDom);
        let myAccrueChart = echarts.getInstanceByDom(accrueChartDom);

        // 如果存在现有的实例，销毁它
        if (myMonthChart) {
          myMonthChart.dispose();
        }

        // 如果存在现有的实例，销毁它
        if (myAccrueChart) {
          myAccrueChart.dispose();
        }

        // 初始化新的 ECharts 实例
        myMonthChart = echarts.init(monthChartDom);
        myMonthChart.setOption(this.getMonthChartOptions(monthData), true);

        // 初始化新的 ECharts 实例
        myAccrueChart = echarts.init(accrueChartDom);
        myAccrueChart.setOption(this.getAccrueChartOptions(accrueData), true);
      }
    },


    getMonthChartOptions(data){
      return {
        title: {
          left: 'left',
          text: '单月KPI'
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: data.lengthData
        },
        xAxis: [
          {
            type: 'category',
            data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月','八月', '九月', '十月', '十一月', '十二月'],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '套数',
          },
        ],
        series: data.seriesData
      }
    },
    getAccrueChartOptions(data){
      return {
        title: {
          left: 'left',
          text: '累积KPI'
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: data.lengthData
        },
        xAxis: [
          {
            type: 'category',
            data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月','八月', '九月', '十月', '十一月', '十二月'],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '套数',
          }
        ],
        series: data.seriesData
      }
    }
  }
}
</script>

<style scoped>

</style>